var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('personal-section',{attrs:{"title":"其他服务","tabs":_vm.tabs,"classname":"more"}})}
var staticRenderFns = []

export { render, staticRenderFns }